"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_2 = require("@headlessui/react");
const constants_1 = require("../constants");
const HEIGHT = 48;
const EditBarClip = styled_1.default.nav({
    left: 0,
    overflow: 'hidden',
    position: 'sticky',
    right: 0,
    top: 0,
    // There's a sidebar in `@bemlo/app` with `z-index: 40`.
    zIndex: 2,
});
const EditBarElement = styled_1.default.div({
    alignItems: 'center',
    backgroundColor: constants_1.Color.LIGHTER_BLUE,
    top: 0,
    boxShadow: constants_1.theme.boxShadow.normal,
    display: 'flex',
    height: HEIGHT,
    left: 0,
    position: 'absolute',
    right: 0,
});
const EditBar = ({ fixedPosition, children, isEditing, marginBottom = 0, }) => {
    const transition = {
        base: (css) => css `
      transition: height ${constants_1.theme.animation.transition}
        ${fixedPosition ? `, margin-bottom ${constants_1.theme.animation.transition}` : ''};
    `,
        from: (css) => css `
      height: 0px;
      ${fixedPosition ? `margin-bottom: 0px;` : ''}
    `,
        to: (css) => css `
      height: ${HEIGHT + marginBottom}px;
      ${fixedPosition ? `margin-bottom: -${HEIGHT + marginBottom}px;` : ''}
    `,
    };
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: ({ css }) => ((0, jsx_runtime_1.jsx)(react_2.Transition, { as: EditBarClip, show: isEditing, enter: transition.base(css), leave: transition.base(css), enterFrom: transition.from(css), enterTo: transition.to(css), leaveFrom: transition.to(css), leaveTo: transition.from(css), children: (0, jsx_runtime_1.jsx)(EditBarElement, { children: children }) })) }));
};
exports.EditBar = EditBar;
